import { createSelector } from 'reselect';
import CompliancePredesResdesMailboxMismatchColumns from '../../containers/CompliancePredesResdesMailboxMismatchColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_RESDES_MAILBOX_MISMATCH.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_RESDES_MAILBOX_MISMATCH.isLoading;

export const getData =
  ReportDefinitions.PREDES_RESDES_MAILBOX_MISMATCH.getDataFunction();

export const getColumns =
  createSelector(getData, CompliancePredesResdesMailboxMismatchColumns);
